import React from "react";

function MonitorRecorderIcon() {
      return (
            <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="40"
                  height="40"
                  fill="none"
                  viewBox="0 0 40 40"
            >
                  <path
                        stroke="#D6EBFF"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M36.667 19.816V21.3c0 5.933-1.484 7.4-7.4 7.4H10.733c-5.916 0-7.4-1.484-7.4-7.4V10.733c0-5.917 1.484-7.4 7.4-7.4h2.6M20 28.7v7.967M3.333 21.667h33.334M12.5 36.667h15"
                  ></path>
                  <path
                        stroke="#D6EBFF"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M29.767 15.616h-7.934c-2.3 0-3.066-1.533-3.066-3.066V6.683c0-1.833 1.5-3.333 3.333-3.333h7.667c1.7 0 3.066 1.366 3.066 3.066v6.134c0 1.7-1.366 3.066-3.066 3.066z"
                  ></path>
                  <path
                        stroke="#D6EBFF"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M34.85 13.2l-2.017-1.417v-4.6l2.017-1.417c1-.683 1.817-.266 1.817.95v5.55c0 1.217-.817 1.634-1.817.934z"
                  ></path>
            </svg>
      );
}

export default MonitorRecorderIcon;
